export enum UserTimeSessionStatus {
    Pending = "Pending",
    Completed = "Completed"
}